// extracted by mini-css-extract-plugin
module.exports = {"titleClass":"styles_titleClass__2txNZ"};